export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m12 19.34-1.164-1.051q-3.118-2.742-4.958-4.883T4 9.05q.037-1.877 1.277-3.117t3.117-1.277q1.052 0 1.991.45A5.1 5.1 0 0 1 12 6.309q.675-.752 1.615-1.202t1.99-.451q1.88.037 3.118 1.277Q19.963 7.171 20 9.049q-.038 2.217-1.878 4.357t-4.958 4.883z\"/>"
};